import React, { useCallback } from "react";
import { ControlledTextfield } from "../../../components/inputs";
import { Button } from "../../../components";

const FormProduto = ({
  props,
  disabled,
  handleSubmit,
  produto,
  voltarParaLista,
}) => {
  const handleClickNext = useCallback(
    (values) => {
      handleSubmit(values, produto.id);
    },
    [handleSubmit, produto]
  );

  return (
    <div className="card spacer">
      <div className="card-body">
        <span className="card-title color-brand">Produto</span>
        <form onSubmit={props.handleSubmit(handleClickNext)}>
          <div className="row">
            <div className="col-12 col-md-3">
              <ControlledTextfield
                name={"codigo"}
                margin={"none"}
                disabled={disabled}
                formProps={props}
                uppercase={true}
                label={"Código"}
                inputProps={{ maxLength: 10 }}
              />
            </div>
            <div className="col-12 col-md-9">
              <ControlledTextfield
                name={"nome"}
                formProps={props}
                uppercase={true}
                disabled={disabled}
                label={"Produto"}
                margin={"none"}
                inputProps={{ maxLength: 40 }}
              />
            </div>
          </div>
          <div className="row spacer">
            <div className="offset-md-2 col-md-4 col-12">
              <Button
                label="Voltar"
                onClick={voltarParaLista}
                loading={produto.loading}
              />
            </div>
            <div className="col-md-4 col-12">
              <Button
                label="CONFIRMAR"
                type={"submit"}
                loading={produto.loading}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormProduto;
